import clsx from "clsx";
import { FCWithClassName } from "types";

export const TariffHeader: FCWithClassName<{ title: string }> = ({
  className,
  title,
}) => {
  return <h3 className={clsx(className, "text-secondary-100")}>{title}</h3>;
};
